import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/account.service";
export class IrregularidadeService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    create(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/irregularidade`, data, { headers: this.account.composeHeaders() });
    }
    read(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/irregularidade/${id}`, { headers: this.account.composeHeaders() });
    }
    update(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/irregularidade/${id}`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/irregularidade/${id}`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/irregularidades`, { headers: this.account.composeHeaders() });
    }
    search(parametro, tipo) {
        return this.http.get(`${SCAMP_API.accountApiV1}/irregularidade-search/${parametro}/${tipo}`, { headers: this.account.composeHeaders() });
    }
    isUniqueDescricaoIrregularidade(descricao, id) {
        return this.http.post(`${SCAMP_API.accountApiV1}/descricao-irregularidade-is-unique`, { descricao, id }, { headers: this.account.composeHeaders() });
    }
    isUniqueDescricaoAbreviadaIrregularidade(descricaoAbreviada, id) {
        return this.http.post(`${SCAMP_API.accountApiV1}/descricao-abreviada-irregularidade-is-unique`, { descricao: descricaoAbreviada, id }, { headers: this.account.composeHeaders() });
    }
}
IrregularidadeService.ngInjectableDef = i0.defineInjectable({ factory: function IrregularidadeService_Factory() { return new IrregularidadeService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: IrregularidadeService, providedIn: "root" });
